/* Barra de compra fija · LEVIOHOME */
(function () {
  var bar = document.getElementById('lv-barra');
  if (!bar) return;
  var mode = bar.dataset.mode;
  var always = bar.dataset.always === 'true';
  var visible = always;
  if (always) document.body.classList.add('lv-barra-fija');
  var ctaVisible = true;
  var footerVisible = false;
  var scrolled = window.scrollY > 120;

  function render() {
    var show = always || (scrolled && !ctaVisible && !footerVisible);
    if (show === visible) return;
    visible = show;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) bar.removeAttribute('inert');
    else bar.setAttribute('inert', '');
  }

  window.addEventListener(
    'scroll',
    function () {
      var s = window.scrollY > (mode === 'collection' ? 400 : 120);
      if (s !== scrolled) {
        scrolled = s;
        render();
      }
    },
    { passive: true }
  );

  // El botón principal de la página: mientras se ve, la barra no hace falta.
  var cta = null;
  if (mode === 'product') {
    cta = document.querySelector('product-info .product-form__submit, .product-form__submit');
  } else if (mode === 'home') {
    cta = document.querySelector('#MainContent .shopify-section:first-child a.button');
  }
  if (cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      ctaVisible = entries[0].isIntersecting;
      render();
    }).observe(cta);
  } else {
    ctaVisible = false;
  }

  // Al llegar al pie de página la barra se retira para no tapar su contenido.
  var footer = document.querySelector('footer.footer');
  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      footerVisible = entries[0].isIntersecting;
      render();
    }).observe(footer);
  }

  if (mode === 'product') {
    var raw = document.getElementById('lv-barra-datos');
    var data = null;
    try {
      data = JSON.parse(raw.textContent);
    } catch (e) {}
    var buy = bar.querySelector('[data-lv-buy]');
    var priceEl = bar.querySelector('[data-lv-price]');
    var compareEl = bar.querySelector('[data-lv-compare]');
    var variantEl = bar.querySelector('[data-lv-variant]');
    var thumbEl = bar.querySelector('[data-lv-thumb]');
    var showCompare = bar.dataset.showCompare === 'true';
    var current = data && data.selected;

    function update(id) {
      var v = data && data.variants[id];
      if (!v) return;
      current = id;
      priceEl.textContent = v.price;
      if (compareEl) {
        var has = showCompare && v.compare;
        compareEl.hidden = !has;
        compareEl.textContent = has ? v.compare : '';
      }
      if (variantEl) variantEl.textContent = v.title;
      if (thumbEl && v.img) thumbEl.src = v.img;
      if (v.available) {
        buy.textContent = buy.dataset.label || buy.textContent;
        buy.classList.remove('is-disabled');
        buy.removeAttribute('aria-disabled');
        buy.removeAttribute('tabindex');
        buy.setAttribute('href', window.routes.cart_url + '/' + id + ':1?channel=buy_button');
      } else {
        buy.classList.add('is-disabled');
        buy.setAttribute('aria-disabled', 'true');
        buy.setAttribute('tabindex', '-1');
        buy.setAttribute('href', '#');
        buy.textContent = bar.dataset.soldOut;
      }
    }

    if (buy && data) {
      buy.dataset.label = bar.dataset.buyLabel || 'Comprar ahora';

      buy.addEventListener('click', function (e) {
        if (buy.classList.contains('is-disabled')) {
          e.preventDefault();
          return;
        }
        var q = document.querySelector('product-info .quantity__input');
        var qty = q ? parseInt(q.value, 10) : 1;
        if (!qty || qty < 1) qty = 1;
        buy.setAttribute('href', window.routes.cart_url + '/' + current + ':' + qty + '?channel=buy_button');
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var variant = event && event.data && event.data.variant;
          if (variant && variant.id) update(String(variant.id));
          else {
            buy.classList.add('is-disabled');
            buy.setAttribute('aria-disabled', 'true');
            buy.setAttribute('href', '#');
            buy.textContent = bar.dataset.unavailable;
          }
        });
      }
    }
  }

  render();
})();
